import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ExpertEventNotificationRecord } from '@libs/shared/api';
import { ExpertEventNotificationWrapperComponent } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification-wrapper.component';
import { injectExpertEventNotificationService } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification.service';

@Component({
  selector:
    'app-credit-point-created-to-referrer-expert-workspace-notification',
  standalone: true,
  imports: [CommonModule, ExpertEventNotificationWrapperComponent],
  template: `
    <app-expert-event-notification-wrapper
      class="cursor-pointer"
      (click)="onClick()"
      [notification]="notification"
      title="친구 초대 완료">
      <div class="text-secondary line-clamp-2">
        {{ notification.notifier.nickname }}님이 친구 초대로 가입하여 크레딧
        포인트를 부여받았어요.
      </div>
    </app-expert-event-notification-wrapper>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreditPointCreatedToReferrerExpertWorkspaceNotificationComponent {
  readonly vm = injectExpertEventNotificationService();
  readonly router = inject(Router);

  @Input({ required: true }) notification: ExpertEventNotificationRecord;

  onClick() {
    this.vm.readExpertEventNotification(this.notification);
    this.router.navigate(
      [
        'expert-workspace',
        this.vm.currentExpertWorkspace$$().id,
        'settings',
        'subscription',
      ],
      {
        onSameUrlNavigation: 'reload',
      }
    );
  }
}
